import { markdownSlug, parseMarkdown } from '../markdown'
import type { DocSection } from '../types'
import type { OpenApiSpec } from './openapiSchema.types'

/** Overview section generated from the OpenAPI document's `info.description`. */
export interface OverviewSection extends DocSection {
  /** The section's `##` heading (or `Introduction` for the text before the first one). */
  title: string
}

const INTRODUCTION = 'Introduction'

/**
 * Converts the overview the backend publishes as `info.description` of the
 * external API document (authentication, standard responses, error codes,
 * pagination, rate limiting, …) into documentation sections, one per `##`
 * heading (`#` is treated the same). Deeper headings become sub-headings.
 * Text goes to the main column, code panels to the aside, titled after the
 * nearest heading.
 */
export function overviewSectionsFromMarkdown(markdown: string): OverviewSection[] {
  const sections: OverviewSection[] = []
  let current: OverviewSection = { id: markdownSlug(INTRODUCTION), title: INTRODUCTION, main: [], aside: [] }
  let codeTitle = INTRODUCTION

  for (const node of parseMarkdown(markdown)) {
    if (node.type === 'heading' && node.level <= 2) {
      if (current.main.length || current.aside?.length) sections.push(current)
      current = { id: markdownSlug(node.text), title: node.text, main: [], aside: [] }
      codeTitle = node.text
    } else if (node.type === 'heading') {
      current.main.push({ type: 'heading', text: node.text, id: `${current.id}-${markdownSlug(node.text)}` })
      codeTitle = node.text
    } else if (node.type === 'code') {
      current.aside!.push({ ...node, title: codeTitle })
    } else {
      current.main.push(node)
    }
  }
  if (current.main.length || current.aside?.length) sections.push(current)

  for (const section of sections) {
    if (section.aside?.length === 0) delete section.aside
  }
  return sections
}

/** Overview sections of an OpenAPI document; empty when it has no `info.description`. */
export function overviewFromOpenApi(spec: OpenApiSpec): OverviewSection[] {
  const description = spec.info?.description?.trim()
  return description ? overviewSectionsFromMarkdown(description) : []
}
